import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "mapRef", "coordinates", "zoom", "handleZoomEnd", "mapStyle", "initialViewState", "touchZoomRotate", "cooperativeGestures", "onMove", "onDrag", "onResize", "onZoom", "style", "interactiveLayerIds", "onClick", "viewState", "reuseMaps", "onLoad", "scrollZoom", "dragRotate", "dragPan", "doubleClickZoom"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { useEffect } from 'react';
import ReactMapGL, { MapProvider } from 'react-map-gl';
import { MapLoadIcon } from '@restworld/utils-common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TRUE = true;
export var mapboxAccessToken = process.env['NX_VERCEL_MAPBOX_ACCESS_TOKEN'] || process.env['STORYBOOK_MAPBOX_ACCESS_TOKEN'];
export var MapWrapper = function MapWrapper(_ref) {
  var _mapRef$current;

  var children = _ref.children,
      mapRef = _ref.mapRef,
      coordinates = _ref.coordinates,
      zoom = _ref.zoom,
      handleZoomEnd = _ref.handleZoomEnd,
      _ref$mapStyle = _ref.mapStyle,
      mapStyle = _ref$mapStyle === void 0 ? 'mapbox://styles/mapbox/streets-v11' : _ref$mapStyle,
      initialViewState = _ref.initialViewState,
      _ref$touchZoomRotate = _ref.touchZoomRotate,
      touchZoomRotate = _ref$touchZoomRotate === void 0 ? TRUE : _ref$touchZoomRotate,
      _ref$cooperativeGestu = _ref.cooperativeGestures,
      cooperativeGestures = _ref$cooperativeGestu === void 0 ? TRUE : _ref$cooperativeGestu,
      onMove = _ref.onMove,
      onDrag = _ref.onDrag,
      onResize = _ref.onResize,
      onZoom = _ref.onZoom,
      style = _ref.style,
      interactiveLayerIds = _ref.interactiveLayerIds,
      onClick = _ref.onClick,
      viewState = _ref.viewState,
      _ref$reuseMaps = _ref.reuseMaps,
      reuseMaps = _ref$reuseMaps === void 0 ? false : _ref$reuseMaps,
      onLoad = _ref.onLoad,
      _ref$scrollZoom = _ref.scrollZoom,
      scrollZoom = _ref$scrollZoom === void 0 ? true : _ref$scrollZoom,
      _ref$dragRotate = _ref.dragRotate,
      dragRotate = _ref$dragRotate === void 0 ? true : _ref$dragRotate,
      _ref$dragPan = _ref.dragPan,
      dragPan = _ref$dragPan === void 0 ? true : _ref$dragPan,
      _ref$doubleClickZoom = _ref.doubleClickZoom,
      doubleClickZoom = _ref$doubleClickZoom === void 0 ? true : _ref$doubleClickZoom,
      rest = _objectWithoutProperties(_ref, _excluded);

  var map = mapRef === null || mapRef === void 0 ? void 0 : (_mapRef$current = mapRef.current) === null || _mapRef$current === void 0 ? void 0 : _mapRef$current.getMap();
  useEffect(function () {
    map === null || map === void 0 ? void 0 : map.on('load', function () {
      map === null || map === void 0 ? void 0 : map.setLayoutProperty('country-label', 'text-field', ['get', "name_it"]);
    });
  }, [map]);
  return /*#__PURE__*/_jsx(MapProvider, {
    children: /*#__PURE__*/_jsx(ReactMapGLStyled, _objectSpread(_objectSpread({
      ref: mapRef,
      initialViewState: initialViewState,
      onZoomEnd: handleZoomEnd,
      mapStyle: mapStyle,
      mapboxAccessToken: mapboxAccessToken,
      touchZoomRotate: touchZoomRotate,
      cooperativeGestures: cooperativeGestures,
      onMove: onMove,
      onDrag: onDrag,
      onResize: onResize,
      attributionControl: false,
      style: style,
      interactiveLayerIds: interactiveLayerIds,
      onClick: onClick,
      onZoom: onZoom,
      reuseMaps: reuseMaps,
      viewState: viewState,
      onLoad: onLoad,
      scrollZoom: scrollZoom,
      dragRotate: dragRotate,
      dragPan: dragPan,
      doubleClickZoom: doubleClickZoom
    }, rest), {}, {
      children: children
    }))
  });
};
export default MapWrapper;

var ReactMapGLStyled = /*#__PURE__*/_styled(ReactMapGL).withConfig({
  displayName: "map-wrapper__ReactMapGLStyled",
  componentId: "sc-p081k8-0"
})({
  "position": "relative"
});

export var MapScriptLoadingUI = function MapScriptLoadingUI() {
  return /*#__PURE__*/_jsx(_StyledDiv, {
    children: /*#__PURE__*/_jsxs(_StyledDiv2, {
      children: [/*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(MapLoadIcon, {})
      }), /*#__PURE__*/_jsx(_StyledSpan, {
        children: "Stiamo facendo girare il mappamondo..."
      })]
    })
  });
};

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "map-wrapper___StyledDiv",
  componentId: "sc-p081k8-1"
})({
  "position": "absolute",
  "display": "flex",
  "height": "100%",
  "width": "100%",
  "alignItems": "center",
  "justifyContent": "center",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(229 231 235 / var(--tw-bg-opacity))"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "map-wrapper___StyledDiv2",
  componentId: "sc-p081k8-2"
})({
  "display": "flex",
  "width": "50%",
  "flexDirection": "column",
  "alignItems": "center",
  "gap": "0.5rem"
});

var _StyledSpan = /*#__PURE__*/_styled("span").withConfig({
  displayName: "map-wrapper___StyledSpan",
  componentId: "sc-p081k8-3"
})({
  "textAlign": "center",
  "fontSize": "1.125rem",
  "lineHeight": "1.75rem",
  "fontWeight": "600",
  "--tw-text-opacity": "1",
  "color": "rgb(107 114 128 / var(--tw-text-opacity))",
  "overflow": "hidden",
  "display": "-webkit-box",
  "WebkitBoxOrient": "vertical",
  "WebkitLineClamp": "2",
  "@media (min-width: 768px)": {
    "width": "50%"
  }
});